import styled from 'styled-components';
import { Modal } from '@shared/components/modals/Modal';

export const FieldWrapper = styled.div<{ margin?: string, width?: string }>`
  display: flex;
  margin: ${({ margin }) => margin};
  width: ${({ width }) => width};
`;

export const FieldGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const SubHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: -35px;
`;

export const SaveButtonWrapper = styled.div`
    display: flex;
    margin-top: 12px;
`;

export const SortModalStyle = styled(Modal)`
  .MuiPaper-root {
    overflow: hidden;
  }
`;